import { render, staticRenderFns } from "./ParentingBuilder.vue?vue&type=template&id=8a7a90a4&scoped=true"
import script from "./ParentingBuilder.vue?vue&type=script&lang=js"
export * from "./ParentingBuilder.vue?vue&type=script&lang=js"
import style0 from "./ParentingBuilder.vue?vue&type=style&index=0&id=8a7a90a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7a90a4",
  null
  
)

export default component.exports